import { render, staticRenderFns } from "./LayoutHome.vue?vue&type=template&id=4059328e&scoped=true"
import script from "./LayoutHome.vue?vue&type=script&lang=js"
export * from "./LayoutHome.vue?vue&type=script&lang=js"
import style0 from "./LayoutHome.vue?vue&type=style&index=0&id=4059328e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059328e",
  null
  
)

export default component.exports